import React from 'react';
import './App.css';
import { getDomainName } from './commons/helpers';
import { domainNameContext, useIsSmartNameDomain } from './commons/hooks';
import { Footer } from './components/Footer';
import { ContactForm } from './components/ContactForm';

function App() {
  const domainName = getDomainName();
  const [isSmartName, errorMessage] = useIsSmartNameDomain(domainName);

  const headerContent = isSmartName ? 'may be for sale' : null;
  let message;
  if (!domainName) {
    message = 'Uh oh, we couldn’t find this page. Please try your search again';
  } else if (errorMessage.length > 0) {
    message = 'Uh oh, something went wrong. We’re working to fix it, so please refresh the page and try again.';
  } else if (!isSmartName) {
    message = 'Unfortunately, this domain is not available right now.';
  }

  return (
    <domainNameContext.Provider value={domainName}>
      <div className='App'>
        <div className='App-header'>
          <h1>{domainName}</h1>
          <span>{headerContent}</span>
        </div>
        <div className='Content'>
          <div className='card'>{message ? <span className='center'>{message}</span> : <ContactForm />}</div>
          <Footer />
        </div>
      </div>
    </domainNameContext.Provider>
  );
}

export default App;
